import { render, staticRenderFns } from "./veStuChange.vue?vue&type=template&id=795de224&scoped=true"
import script from "./veStuChange.vue?vue&type=script&lang=js"
export * from "./veStuChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795de224",
  null
  
)

export default component.exports